import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpXsrfTokenExtractor,
} from "@angular/common/http";
import { KeycloakService } from "./keycloak.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private keycloakService: KeycloakService,
    private tokenExtractor: HttpXsrfTokenExtractor
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authToken = this.keycloakService.getToken() || "";
    //const token = this.tokenExtractor.getToken() as string;

    request = request.clone({
      setHeaders: {
        Authorization: "Bearer " + authToken,
        accept: "*/*",
        //'X-XSRF-TOKEN': token
      },
    });
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401) {
          //localStorage.clear();
          this.keycloakService.logout();
          //window.location.reload();
        }
        return throwError(error);
      })
    );
  }
}
